import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import dynamicfunction from '../../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../../utils/utils';
import {
  deleteDocument,
  getKycUploadDocumentVault,
  getUploadDocuments,
  updateKycDocument,
  addDocument,
} from '../../../store/actions/corporateAction';
import { RowView, Text, UploadCard } from '../components';
import Dropdown from '../../../components/Dropdown';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router';
import icons from '../../../constants/icons';
import { ReactSVG } from 'react-svg';
import { logoutUser } from '../../../store/actions/authActions';

const DocumentVault = ({ onDone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isArabic } = dynamicfunction();

  const { corporate, language } = useSelector((state) => state.content);
  const { document_types, uploaded_documents, corporate_post_loading } =
    useSelector((state) => state.corporate);
    const {
    client_application_id,
    is_kyc,
    company_id,
    is_ksa_corporate,
  } = useSelector((state) => state.constant);

  const getContent = (key) => {
    return getContentKeyAccToLang(corporate?.corporate_document_vault?.data?.attributes, key, isArabic);
  };
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const listsEdited = useRef(false);

  useEffect(() => {
    // After a language switch, keep the additional documents the user already selected (only relabel them).
    const setLists = (additionalDocs) => {
      if (listsEdited.current) {
        setSelectedDocuments((prev) => prev?.map((item) => ({ ...item, name: isArabic ? item?.fileKeyAr : item?.fileKeyEn })));
        return;
      }
      setSelectedDocuments(additionalDocs);
    };

    // dispatch(getDocumentTypes(company_id));
      is_kyc
      ? dispatch(
        getKycUploadDocumentVault(client_application_id, (data) => {
            const additionalDocs = data
              ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
              ?.map((item) => ({
                ...item,
                id: item?.documentTypeId,
                name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
              }));
            setLists(additionalDocs);
          })
        )
        : dispatch(
        getUploadDocuments(client_application_id, (data) => {
            const additionalDocs = data
              ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
              ?.map((item) => ({
                ...item,
                id: item?.documentTypeId,
                name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
              }));
            setLists(additionalDocs);
          }))
  }, [language]);

  const uploadDocument = (id, file) => {
    const formData = new FormData();
    formData.append('ClientApplicationId', client_application_id);
    formData.append('DocumentTypeId', id);
    formData.append('Document', file);
    is_kyc ?
    dispatch(
      updateKycDocument(formData, () => {
            dispatch(
              getKycUploadDocumentVault(client_application_id, (data) => {
                const additionalDocs = data
                  ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
                  ?.map((item) => ({
                    ...item,
                    id: item?.documentTypeId,
                    name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
                  }));
                setSelectedDocuments(additionalDocs);
              })
            )
      })
    )
    :
    dispatch(
      addDocument(formData, () => {
            dispatch(
              getUploadDocuments(client_application_id, (data) => {
                const additionalDocs = data
                  ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
                  ?.map((item) => ({
                    ...item,
                    id: item?.documentTypeId,
                    name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
                  }));
                setSelectedDocuments(additionalDocs);
              }),
            );
      }),
    );
  };

  const handleDeleteDocument = (payloadId) => {
    const params = `${client_application_id}&documentPayloadId=${payloadId}`;
    dispatch(
      deleteDocument(params, () => {
        is_kyc 
        ? dispatch(
          getKycUploadDocumentVault(client_application_id, (data) => {
            const additionalDocs = data
              ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
              ?.map((item) => ({
                ...item,
                id: item?.documentTypeId,
                name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
              }));
            setSelectedDocuments(additionalDocs);
          }),
        )
        : dispatch(
          getUploadDocuments(client_application_id, (data) => {
            const additionalDocs = data
              ?.filter((item) => item?.isAdditionalDocument && item?.fileName)
              ?.map((item) => ({
                ...item,
                id: item?.documentTypeId,
                name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
              }));
            setSelectedDocuments(additionalDocs);
          }),
        );
      }),
    );
  };

  return (
    <>
      <div>
        <div dir={isArabic ? 'rtl' : 'ltr'} className='grid grid-cols-1 md:grid-cols-2 gap-10'>
          {uploaded_documents?.length > 0
            ? uploaded_documents
                ?.filter((doc) => doc?.isAdditionalDocument === false)
                .map((doc) => {
                  return (
                    <UploadCard
                      key={doc?.documentTypeId}
                      title={isArabic ? doc?.fileKeyAr : doc?.fileKeyEn}
                      name={doc?.fileName ?? null}
                      description={getContent('file_upload_max_10mb')}
                      upload={getContent(doc?.fileName ? 'update' : 'upload')}
                      onClick={(file) => uploadDocument(doc?.documentTypeId, file)}
                      onDeleteDocument={() => handleDeleteDocument(doc?.payloadId)}
                    />
                  );
                })
            : null}
        </div>

        {is_ksa_corporate && (
          <div className='mt-10'>
            <Dropdown
              label={getContent('upload_additional_documents')}
              options={
                uploaded_documents
                  ?.filter((item) => item?.isAdditionalDocument === true)
                  ?.map((item) => ({
                    ...item,
                    id: item?.documentTypeId,
                    name: isArabic ? item?.fileKeyAr : item?.fileKeyEn,
                  })) || []
              }
              selectedValue={selectedDocuments}
              valueKey={'name'}
              isMulti
              onSelect={(val, selected) => {
                const exist = selectedDocuments.find((doc) => doc?.documentTypeId === selected?.documentTypeId);

                if (exist && selected?.fileName) {
                  handleDeleteDocument(selected?.payloadId);
                }

                listsEdited.current = true;
                setSelectedDocuments(val);
              }}
            />

            <RowView className='flex-wrap gap-4 mt-4'>
              {selectedDocuments?.map((item) => (
                <RowView className='bg-primary/10 py-2 px-4 rounded items-center gap-2'>
                  <Text text={isArabic ? item?.fileKeyAr : item?.fileKeyEn} />

                  <ReactSVG
                    src={icons.close_icon}
                    className='cursor-pointer'
                    onClick={() => {
                      item?.payloadId && handleDeleteDocument(item?.payloadId);
                      const filteredDocs = selectedDocuments?.filter((doc) => doc?.documentTypeId !== item?.documentTypeId);
                      listsEdited.current = true;
                      setSelectedDocuments(filteredDocs);
                    }}
                  />
                </RowView>
              ))}
            </RowView>

            <div dir={isArabic ? 'rtl' : 'ltr'} className='grid grid-cols-1 md:grid-cols-2 gap-10 mt-6'>
              {selectedDocuments.map((doc) => {
                const existingDoc = uploaded_documents?.find((d) => d?.documentTypeId === doc?.documentTypeId);
                return (
                  <UploadCard
                    key={doc?.documentTypeId}
                    title={isArabic ? doc?.fileKeyAr : doc?.fileKeyEn}
                    name={existingDoc?.fileName ?? null}
                    description={getContent('file_upload_max_10mb')}
                    upload={getContent(existingDoc?.fileName ? 'update' : 'upload')}
                    onClick={(file) => uploadDocument(doc?.documentTypeId, file)}
                    onDeleteDocument={() => handleDeleteDocument(doc?.payloadId)}
                  />
                );
              })}
            </div>
          </div>
        )}

        <div className='w-full h-0.5 bg-border mt-3 sm:mt-5'></div>
        <RowView className='gap-7 pt-3 sm:pt-5'>
          <Button
            text={getContent('save_and_proceed')}
            color={'text-white hover:text-primary '}
            bgColor='bg-primary hover:bg-transparent hover:border-primary'
            className={'border border-transparent w-44 px-0 text-center'}
            isDisabled={corporate_post_loading}
            loading={corporate_post_loading}
            onClick={() => onDone()}
          />
          <Button
            text={getContent('save_and_exit')}
            color={'text-primary hover:text-white'}
            bgColor='bg-white hover:bg-primary'
            className={'border border-primary w-44 px-0 text-center'}
            isDisabled={corporate_post_loading}
            onClick={() => (is_kyc ? navigate('/funds/available-funds') : dispatch(logoutUser()))}
          />
        </RowView>
      </div>
    </>
  );
};

export default DocumentVault;
